// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Th84","inner":"Footer_inner__3K6if","nextIcon":"Footer_nextIcon__1-HcR","innerLeft":"Footer_innerLeft__3vyDQ"};